<template>
  <div class="mall-search-bar" @click="$emit('click')">
    <input
      ref="input"
      class="mall-search-bar__input"
      type="search"
      :placeholder="placeholder"
      :value="value"
      :readonly="readonly"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('search', value)"
    />
    <div class="mall-search-bar__button" @click="$emit('search', value)">
      <img src="@/assets/mall/icn_search_line.svg" alt="검색" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallSearchBar',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '상품을 검색해 보세요',
    },
    // 입력 없이 누르기만 하는 용도 (쇼핑 홈 → 검색 화면 이동)
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus()
    }
  },
  methods: {
    blur() {
      this.$refs.input.blur()
    },
  },
}
</script>

<style scoped>
.mall-search-bar {
  display: flex;
  height: 48px;
  padding: 0 16px;
  align-items: center;
  gap: 4px;
  border: 1px solid #D1D6DB;
  border-radius: 8px;
  background: #FFF;
  box-sizing: border-box;
}

/* Focused: 2px #0096FF (레이아웃이 밀리지 않도록 inset shadow로 1px 보강) */
.mall-search-bar:focus-within {
  border-color: #0096FF;
  box-shadow: inset 0 0 0 1px #0096FF;
}

.mall-search-bar__input {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  outline: none;
  background: transparent;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  -webkit-appearance: none;
}

/* type="search"의 브라우저 기본 지우기 버튼 / 장식 숨김 */
.mall-search-bar__input::-webkit-search-cancel-button,
.mall-search-bar__input::-webkit-search-decoration {
  -webkit-appearance: none;
}

.mall-search-bar__input::placeholder {
  color: #8B95A1;
}

.mall-search-bar__input:focus::placeholder {
  color: #6B7684;
}

.mall-search-bar__input[readonly] {
  cursor: pointer;
}

.mall-search-bar__button {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
}

.mall-search-bar__button img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallSearchBar.vue